import React from "react";
import FlexibleTable from "../../modules/FlexibleTable";
import TableCentricPage from "../../modules/TableCentricPage";

import Api from "../../utils/Api";
import TableLeftPanel from "../../utils/TableLeftPanel";
import { formatUnixTimestampTz } from "../../utils/DateTimeUtil";
import { formatBytes } from "../../utils/StringUtil";
import { useSessionStore } from "../../storez/SessionStore";
import { withToast } from "../../utils/ReactUtil";

class DiagnosticsLogfiles extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      logfiles: [],
      loaded: false,
      tzString: this.props.timezone || useSessionStore.getState().getDevice().timezone,
    };
  }

  handle_load = () => {
    let self = this;
    Api.get("/managedevice/ajax/device/logfiles", function (result) {
      const data = result["data"] ?? [];

      data.forEach((i) => {
        // Parse the time the file was archived (a much more useful piece of
        // information than when it was uploaded) out of the file name. This
        // should probably be an actual meta-data field but this will do for
        // now. 10 = digits in epoch time stamp between 2001 and 2286
        const m = i["file"].match(/\.archived\.(?<epoch>\d{10})[._]/);
        i.archived_timestamp = m ? m.groups.epoch : undefined;
      });

      self.setState({
        logfiles: data,
        loaded: true,
      });
    });
  };

  componentDidMount() {
    this.handle_load();
  }

  render__buttons = () => {
    return <div />;
  };

  handle_Download = (file_entity) => {
    Api.get(
      "/managedevice/ajax/device/logfile/" + file_entity["file"],
      (data) => {
        window.open(data.url, "_blank");
      },
      () => {
        this.props.errorToast({
          title: "Please try again",
          description: "An unexpected error occurred while downloading the file.",
        });
      }
    );
  };

  render__content = () => {
    let self = this;
    let columns = [
      {
        title: "Upload Time",
        data: (row) => formatUnixTimestampTz(row["timestamp"], self.state.tzString),
        sortable: FlexibleTable.sortable__multi_string_field("timestamp", "file"),
        search: FlexibleTable.search__single_date_field("timestamp", self.state.tzString),
        onclick: undefined,
      },
      {
        title: "Archive Time",
        data: (row) => formatUnixTimestampTz(row["archived_timestamp"], self.state.tzString),
        sortable: FlexibleTable.sortable__multi_string_field("archived_timestamp", "file"),
        search: FlexibleTable.search__single_date_field("archived_timestamp", self.state.tzString),
        onclick: undefined,
      },
      {
        title: "Filename",
        data: function (row) {
          return row["file"];
        },
        sortable: FlexibleTable.sortable__single_string_field("file"),
        search: FlexibleTable.search__single_string_field("file"),
        onclick: undefined,
      },
      {
        title: "File Size",
        data: function (row) {
          const size = row["file_size"];
          return size == /* sic */ null || size < 0 ? "" : formatBytes(size);
        },
        sortable: FlexibleTable.sortable__single_string_field("file_size"),
        search: FlexibleTable.search__single_string_field("file_size"),
        onclick: undefined,
      },
      {
        title: "Operations",
        data: function (row) {
          return (
            <div className="link-button" onClick={() => self.handle_Download(row)}>
              Download
            </div>
          );
        },
        onclick: undefined,
      },
    ];

    return <FlexibleTable columns={columns} data={this.state.logfiles} loaded={this.state.loaded} sort_asc={false} sort_column={1} />;
  };

  render() {
    return (
      <TableLeftPanel>
        <TableCentricPage icon="fa fa-file" title="Logfiles" buttons={this.render__buttons()} content={this.render__content()} />
      </TableLeftPanel>
    );
  }
}

export default withToast(DiagnosticsLogfiles);
